import Nanobus from "nanobus";
import AcHtmlElement from "../helpers/html-element";
import AcHookableFilters from "./ac-hookable-filters";
export default class AcServices {
    constructor() {
        this.services = {};
        this.events = new Nanobus();
        this.filters = new AcHookableFilters();
        this.$ = AcHtmlElement;
    }
    registerService(name, service) {
        this.services[name] = service;
        this.events.emit(`Service.Registered.${name}`, service);
        return this;
    }
    getService(name) {
        return this.hasService(name) ? this.services[name] : null;
    }
    hasService(name) {
        return this.services.hasOwnProperty(name);
    }
    addListener(name, callback) {
        this.events.addListener(name, callback);
    }
    emitEvent(name, args) {
        this.events.emit(name, args);
    }
}
